import { render, staticRenderFns } from "./WidgetFooter.vue?vue&type=template&id=2c0ca43e&scoped=true&"
import script from "./WidgetFooter.vue?vue&type=script&lang=js&"
export * from "./WidgetFooter.vue?vue&type=script&lang=js&"
import style0 from "./WidgetFooter.vue?vue&type=style&index=0&id=2c0ca43e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0ca43e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c0ca43e')) {
      api.createRecord('2c0ca43e', component.options)
    } else {
      api.reload('2c0ca43e', component.options)
    }
    module.hot.accept("./WidgetFooter.vue?vue&type=template&id=2c0ca43e&scoped=true&", function () {
      api.rerender('2c0ca43e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/widget-preview/components/WidgetFooter.vue"
export default component.exports